<template>
	<v-col cols="12">
		<v-row>
			<v-col cols="4" md="4" sm="4" class="align-self-end">
				<datePicker
					v-model="desde"
					format="YYYY-MM-DD"
					label="Desde (Obligatorio)"
					clearable
					maxToday
					@input="onFechasInput"
					:disabled="cargando"
				></datePicker>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="align-self-end">
				<datePicker
					v-model="hasta"
					:minDate="desde"
					format="YYYY-MM-DD"
					label="Hasta (Obligatorio)"
					clearable
					maxToday
					@input="onFechasInput"
					:disabled="cargando"
				></datePicker>
			</v-col>
			<v-col cols="4">
				<v-autocomplete
					v-model="idsPersonas"
					label="Operador(es) (Opcional)"
					:items="personas"
					item-value="idPersona"
					:item-text="nombrePersona"
					hide-details
					multiple
					clearable
					chips
					deletable-chips
					@input="vista === 'historial' ? onFechasInput : obtenerDatos()"
					:loading="cargando"
				></v-autocomplete>
			</v-col>
			<v-col cols="4">
				<v-autocomplete
					v-model="idArea"
					label="Área (Opcional)"
					:items="areas"
					item-value="idArea"
					item-text="nombre"
					hide-details
					clearable
					:disabled="cargando"
					@change="refrescarVista()"
				></v-autocomplete>
			</v-col>
			<v-col cols="4">
				<v-autocomplete
					v-model="idTurno"
					:items="turnos"
					item-text="nombre"
					item-value="idTurno"
					label="Turno (Opcional)"
					hide-details
					clearable
					@change="refrescarVista()"
					:disabled="cargando"
				></v-autocomplete>
			</v-col>
		</v-row>
		<v-row v-if="desde != null && hasta != null">
			<v-col cols="4">
				<download-btn
					color="primary"
					text
					@click="descargarReporte"
					label="Descargar Reporte de<br>Eficiencia de Operadores"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="d-flex justify-end">
				<v-btn-toggle v-model="vista" dense mandatory>
				<v-btn color="primary" value="eficiencia" small>
					Reporte de Eficiencia
				</v-btn>
				<v-btn color="primary" value="historial" small>
					Evaluación de Uso del Sistema
				</v-btn>
				</v-btn-toggle>
			</v-col>
		</v-row>
		<v-dialog
			v-model="dialogHistorialDias"
			max-width="1200"
			scrollable
			transition="dialog-transition"
			persistent
			>
			<v-card>
				<v-toolbar dense flat>
				<v-toolbar-title class="text-subtitle-1">
					Días con modificaciones{{ selectedHistOpName ? ` - ${selectedHistOpName}` : "" }}
				</v-toolbar-title>
				</v-toolbar>

				<v-divider />

				<v-card-text style="height: 60vh;">
				<v-data-table
					:headers="historialDiasHeaders"
					:items="historialDiasItems"
					:items-per-page="-1"
					hide-default-footer
					dense
					fixed-header
					height="55vh"
					class="elevation-1"
					show-expand
					single-expand
					item-key="dia"
				>
					<template v-slot:[`item.dia`]="{ item }">
					<span class="mx-fecha-cell">{{ formatDia(item.dia) }}</span>
					</template>

					<template v-slot:[`item.cantidadEdiciones`]="{ item }">
					<v-chip x-small label color="primary" dark>
						{{ item.cantidadEdiciones }}
					</v-chip>
					</template>
					<!-- <template v-slot:[`item.ultimaHora`]="{ item }">
					<span class="text-no-wrap">{{ item.ultimaHora || "—" }}</span>
					</template> -->
					<template v-slot:[`item.tipoEdicionLabel`]="{ item }">
					<v-chip x-small label :color="item.tipoEdicionLabel.includes('Paro') ? 'warning' : 'info'" dark>
						{{ item.tipoEdicionLabel }}
					</v-chip>
					</template>
					<template v-slot:[`item.inicioAntes`]="{ item }">
					<span class="mx-fecha-cell">{{ formatFechaHora(item.inicioAntes) }}</span>
					</template>
					<template v-slot:[`item.inicioDespues`]="{ item }">
					<span class="mx-fecha-cell">{{ formatFechaHora(item.inicioDespues) }}</span>
					</template>
					<template v-slot:[`item.finAntes`]="{ item }">
					<span class="mx-fecha-cell">{{ formatFechaHora(item.finAntes) }}</span>
					</template>
					<template v-slot:[`item.finDespues`]="{ item }">
					<span class="mx-fecha-cell">{{ formatFechaHora(item.finDespues) }}</span>
					</template>

					<!-- Expandible pa información más detallada -->
					<template v-slot:expanded-item="{ headers, item }">
						<td :colspan="headers.length" class="pa-3">
							<v-simple-table dense>
							<thead>
								<tr>
								<th>Fecha</th>
								<th>Tipo</th>
								<th>Inicio Antes</th>
								<th>Inicio Después</th>
								<th>Fin Antes</th>
								<th>Fin Después</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(e, i) in (item.detalles || [])" :key="item.dia + '-' + i">
								<td class="text-no-wrap">{{ formatFechaHora(e.fechaEdicion) }}</td>
								<td>
									<v-chip x-small label :color="e.tipoEdicion === 2 ? 'orange' : 'primary'" dark>
									{{ e.tipoEdicionLabel }}
									</v-chip>
								</td>
								<td class="text-no-wrap">{{ formatFechaHora(e.inicioAntes) }}</td>
								<td class="text-no-wrap">{{ formatFechaHora(e.inicioDespues) }}</td>
								<td class="text-no-wrap">{{ formatFechaHora(e.finAntes) }}</td>
								<td class="text-no-wrap">{{ formatFechaHora(e.finDespues) }}</td>
								</tr>
							</tbody>
							</v-simple-table>
						</td>
					</template>
				</v-data-table>
				</v-card-text>

				<v-divider />

				<v-card-actions class="justify-end">
				<v-btn text color="primary" @click="closeDialogHistorialDias()">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-row>
			<v-col cols="12">
				<v-progress-linear v-if="cargando" color="primary" height="5" indeterminate />

				<!-- VISTA: EFICIENCIA -->
				<div v-if="vista === 'eficiencia'">
				<apexchart
					type="bar"
					height="500"
					:options="chartOptions"
					:series="series"
				/>
				</div>

				<!-- VISTA: HISTORIAL -->
				<div v-else>
					<v-progress-linear
						v-if="cargandoHistorial"
						color="primary"
						height="5"
						indeterminate
						class="mb-2"
					/>

					<apexchart
						type="bar"
						height="500"
						:options="historialChartOptions"
						:series="historialSeries"
					/>
				</div>
			</v-col>
		</v-row>
		<v-dialog v-model="infoDetalle" persistent max-width="1800" scrollable transition="dialog-transition">
			<v-card>
				<v-toolbar dense flat>
				<v-toolbar-title class="text-subtitle-1">
					Detalle de Operaciones{{ selectedOpName ? ` - ${selectedOpName}` : "" }}
				</v-toolbar-title>
				</v-toolbar>

				<v-divider />
			<v-card-text style="height: 70vh;">
				<div class="mx-xscroll-sticky" ref="stickyX">
				  <div ref="stickyXInner" class="mx-xscroll-inner"></div>
				</div>		
			<v-data-table
				ref="detalleTable"	
				class="mx-detalle-table"
				:headers="headers"
				:items="reportes"
				:loading="cargandoTable"
				:sort-by="['eficiencia']"
				:sort-desc="[true]"
				dense
				loading-text="Cargando... Espere por favor"
				>
				<template v-slot:[`item.extemporaneo`]="{ item }">
					<v-tooltip v-if="item.extemporaneo" bottom color="black" class="white--text">
					<template v-slot:activator="{ on }">
						<v-icon
						v-on="on"
						color="error"
						>
						mdi-clock-outline
						</v-icon>
					</template>
					<span class="white--text">Extemporáneo</span>
					</v-tooltip>
				</template>
				<template v-slot:[`item.tipoOperacion`]="{ item }">
					<div v-if="item.tipoOperacion == 1">Normal</div>
					<div v-if="item.tipoOperacion == 2">Liberación</div>
				</template>
				<template v-slot:[`item.proceso`]="{ item }">
							<div>
								<!-- Artículo: {{item.articuloProducir}} -->
								<!-- <br>
								Fase: {{item.articuloFase}} -->
					<div v-if="item.codigoArticulo != null">
						[{{item.codigoArticulo}}] - {{item.articuloProducir}}
					</div>
					<div v-else>{{item.articuloProducir}}</div>
							</div>
						</template>
				<template v-slot:[`item.paso`]="{ item }">
					<div v-if="item.codigoArticuloFase != null">
					[{{item.codigoArticuloFase}}] - {{item.paso}}
					</div>
					<div v-else >{{item.paso}}</div>
				</template>
				<!-- <template v-slot:[`item.operadores`]="{ item }">
					<ul>
					<li v-for="(op,idx) in item.operadores" :key="'op'-idx">{{op}}</li>
					</ul>
				</template> -->
				<template  v-slot:[`item.cantidad`]="{ item }">
					{{item.cantidad.toFixed(2)}} {{item.unidad}}
				</template>
				<template v-if="nombreEmpresa == 'MYC'" v-slot:[`item.auxiliar`]="{ item }">
					<p v-if="item.unidadAuxiliar == null || item.unidadAuxiliar == '' " >N/D</p>
					<p v-else-if="item.cantidadAuxiliar === null || item.cantidadAuxiliar === undefined || /^\s*$/.test(item.cantidadAuxiliar) === ''" > {{  0}} {{item.unidadAuxiliar}}</p>
					<p v-else >{{ item.cantidadAuxiliar.toFixed(2)}} {{item.unidadAuxiliar}}</p>
				</template>
				<!-- <template v-slot:[`item.std`]="{ item }">
					<span v-if="diferenteHora(item)">0</span>
					<span v-else-if="mostrarSTD(item)">{{ Number(item.std).toFixed(2) }}</span>
					<span v-else>—</span>
				</template> -->
				<template v-slot:[`item.std`]="{ item }">
					<span v-if="!ocultarStd(item)" >{{ Number(item.std).toFixed(2) }}</span>
				</template>
				<template v-slot:[`item.cantidadNoOk`]="{ item }">
					{{item.cantidadNoOk.toFixed(2)}} {{item.unidad}}
				</template>
				<template v-slot:[`item.costoTotal`]="{ item }">
					${{item.costoTotal.toFixed(2)}}
				</template>
				<template v-slot:[`item.eficiencia`]="{ item }">
					{{getEficienciaDisplay(item).toFixed(2)}}%
				</template>
				<template v-slot:[`item.pagoDestajo`]="{ item }">
					${{item.pagoDestajo.toFixed(2)}}
				</template>
				<template v-if="nombreEmpresa == 'MYC'" v-slot:[`item.tiempoParo`]="{ item }">
					{{item.tiempoParo == null ? 'N/D': item.tiempoParo}}
				</template>
				<template v-slot:[`item.paros`]="{ item }">
					<div v-if="Array.isArray(item.paros) && item.paros.length">
						<div
						v-for="p in item.paros"
						:key="p.idParo"
						class="d-flex align-center justify-space-between py-1"
						>
						<div class="mr-2" style="min-width: 0;">
							<div class="text-caption font-weight-medium">{{ p.causa || 'N/D' }}</div>
							<div class="text-caption grey--text">
							{{ p.inicio }} → {{ p.fin }} ({{ (p.duracionMin || 0).toFixed(1) }} min)
							</div>
						</div>

						<v-icon small class="ml-2" @click="showDialogEditParo(p)">
							mdi-pencil
						</v-icon>
						</div>
					</div>
					<span v-else class="grey--text">Sin paros</span>
				</template>
				<template v-if="nombreEmpresa == 'MYC'" v-slot:[`item.merma`]="{ item }">
					{{ item.merma}}
				</template>
				<template v-if="nombreEmpresa == 'MYC'" v-slot:[`item.scrap`]="{ item }">
					{{ item.scrap}}
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<v-icon
						small
						class="mr-2"
						@click="showDialogEdit(item.idOperacionReal, item.inicio, item.fin)"
						>
							edit
					</v-icon>
				</template>
			</v-data-table>		
			</v-card-text>
			<v-divider />
			<v-card-actions class="justify-end">
			<v-btn text color="primary" @click="closeInfoDetalle()">
				Cerrar
			</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
		<v-dialog v-model="dialogEditParo" max-width="410" persistent>
			<v-card>
				<v-card-title class="text-h5">
				Editar tiempo de paro
				</v-card-title>
				<v-card-text>
				<v-row>
					<v-col cols="12">
					<VueCtkDateTimePicker
						:key="'paroInicio-' + paroDialogKey"
						id="paroInicio"
						v-model="paroInicio"
						label="Inicio"					
						format="YYYY-MM-DD HH:mm"
						formatted="YYYY-MM-DD HH:mm"
						noHeader
						overlay
						buttonNowTranslation="Ahora"
						:error="!!errorInicioParo"
  						:error-messages="errorInicioParo"
					/>
					<div v-if="errorInicioParo" class="error--text text-caption mt-1">
						{{ errorInicioParo }}
					</div>
					</v-col>

					<v-col cols="12">
					<VueCtkDateTimePicker
						:key="'paroFin-' + paroDialogKey"
						id="paroFin"
						v-model="paroFin"
						label="Fin"	
						format="YYYY-MM-DD HH:mm"
						formatted="YYYY-MM-DD HH:mm"
						noHeader
						overlay
						buttonNowTranslation="Ahora"
						:error="!!errorFinParo"
  						:error-messages="errorFinParo"
					/>
					<div v-if="errorFinParo" class="error--text text-caption mt-1">
						{{ errorFinParo }}
					</div>
					</v-col>
					<v-col cols="12">
					<v-select
						v-model="paroEdit.idParoTipo"
						:items="tipoParos"
						item-text="nombre"
						item-value="idParoTipo"
						label="Causa"
						dense
						@change="paroEdit.idSubParoTipo = null"
					/>
					</v-col>

					<v-col cols="12" v-if="tipoSubparos.length">
					<v-select
						v-model="paroEdit.idSubParoTipo"
						:items="tipoSubparos"
						item-text="nombreSubParoTipo"
						item-value="idSubParoTipo"
						label="Subcausa (opcional)"
						dense
						clearable
					/>
					</v-col>
				</v-row>
				</v-card-text>

				<v-card-actions>
				<v-spacer />
				<v-btn text color="red darken-1"
					@click="cerrarParo()"
					:loading="loadSaveParo"
					:disabled="loadSaveParo"
				>
					cancelar
				</v-btn>

				<v-btn text color="green darken-1"
					@click="guardarParo()"
					:loading="loadSaveParo"
					:disabled="loadSaveParo || !puedeGuardarParo"
				>
					guardar
				</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogEditHour"
			max-width="410"
			persistent
			>
			<v-card>
			<v-card-title class="text-h5">
				Editar fecha de inicio y finalización de la operación
			</v-card-title>

			<v-card-text>
				<v-row>
				<v-col cols="12" md="12">
				<VueCtkDateTimePicker
					id="fechaM1"
					v-model="inicio"
					label="Inicio"	
					format="YYYY-MM-DD HH:mm"
					formatted="YYYY-MM-DD HH:mm"
					noHeader
					overlay
					buttonNowTranslation="Ahora"
					:error="errores.errorInicio"
					:error-messages="errores.errorInicioTexto"
				/>
				</v-col>
				<v-col cols="12" md="12">
				<VueCtkDateTimePicker
					id="fechaM2"
					v-model="fin"
					label="Fin"
					format="YYYY-MM-DD HH:mm"
					formatted="YYYY-MM-DD HH:mm"
					noHeader
					overlay
					buttonNowTranslation="Ahora"
					:error="errores.errorFin"
					:error-messages="errores.errorFinTexto"
				/>
				</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
				color="red darken-1"
				text
				@click="dialogEditHour = false"
				:loading="loadSave"
				:disabled="loadSave"
				>
				cancelar
				</v-btn>

				<v-btn
				color="green darken-1"
				text
				@click="sendDataDate()"
				:loading="loadSave"
				:disabled="loadSave || !puedeGuardarFechas"
				>
				guardar
				</v-btn>
			</v-card-actions>
			</v-card>
		</v-dialog>
	</v-col>
</template>

<script>
import axios from "axios";
import DownloadBtn from '../../DownloadBtn.vue';
import { mapState } from 'vuex';
import moment from 'moment';
export default {
	components: { DownloadBtn },
	data() {
		return {
			categories: [],
			series: [],
			desde: null,
			hasta: null,
			idArea: null,
			areas: [],
			idTurno: null,
			turnos: [],
			idsPersonas: [],
			personas: [],
			cargando: false,
			reportes: [],
			cargandoTable: false,
			infoDetalle: false,
			rowsRaw: [],
			opIdsByBarIndex: [],
			opNameByBarIndex: [],
			selectedOpId: null,
			selectedOpName: "",
			idOperacionReal : null,
			inicio : null,
			fin: null,
			dialogEditHour : false,
			loadSave: false,
			historialEdiciones: [],
			puedeGuardarFechas: false,
			vista: "eficiencia",          // 'eficiencia' | 'historial'
			cargandoHistorial: false,
			personasHistorial: [],
			//historialHeaders: [],
			//historialItems: [],
			selectedHistOpId: null,
   			selectedHistOpName: "",
			cargandoFechas: false,
			historialReady: false,
			_reqKey: 0,
			_fechasTimer: null,
			historialDiasHeaders: [
				{ text: "Fecha Modificación", value: "ultimaFecha", align: "center" },
				{ text: "Ediciones", value: "cantidadEdiciones", align: "center" },
				{ text: "Tipo", value: "tipoEdicionLabel", align: "center" },
				{ text: "Inicio Antes", value: "inicioAntes", align: "center" },
				{ text: "Inicio Después", value: "inicioDespues"},
				{ text: "Fin Antes", value: "finAntes", align: "center" },
				{ text: "Fin Después", value: "finDespues" },
				{ text: "", value: "data-table-expand", width: 1 }
			],
			paroDialogKey: 0,
			tipoParos: [],
			tipoSubparos: [],
			dialogEditParo: false,
			loadSaveParo: false,
			paroInicio: null,
			paroFin: null,
			paroCausa: null,
			paroEdit: {
			idParo: null,
			idParoTipo: null,
			idSubParoTipo: null,
			condicion: true,
			},
			erroresParo: {
			errorInicio: false,
			errorInicioTexto: null,
			errorFin: false,
			errorFinTexto: null,
			},
			paroEdit: { idParo:null, idParoTipo:null, idSubParoTipo:null, activo:true, inicio:null, fin:null, causa:null },
			showStickyXScroll: false,
			_syncingX: false,
			_onResize: null,
			historialDiasItems: [],
			idsOperadoresReporte: [],
			mapOperadorNombre: {},   // idPersona => "Nombre Apellido"
			idsByCategory: [],            // lo usas en dataPointSelection
			idsByHistCategory: [],

			errores:{
				errorInicio:false,
				errorInicioTexto: null,
				errorFin:false,
				errorFinTexto: null
			},
			 headers:[
				{
					text: "",
					align: "center",
					value: "extemporaneo"
				},
				{
					text: "Tipo de Operación",
					align: "center",
					sortable: true,
					value: "tipoOperacion",
				},
				{ 
					text: "OT",
					align: "center",
					sortable: true,
					value: "ot",
				},
				{ 
					text: "Área",
					align: "center",
					sortable: true,
					value: "area",
				},
				{
					text: "Proceso",
					align: "center",
					sortable: false,
					value: "proceso",
					width: '20%'
				},
				{ 
					text: "Fase",
					align: "center",
					sortable: true,
					value: "paso",
				},
				{ 
					text: "SubPaso",
					align: "center",
					sortable: true,
					value: "subpaso",
				},
				// { 
				// 	text: "Operadores",
				// 	align: "center",
				// 	sortable: true,
				// 	value: "operadores",
				// },
				{ 
					text: "Inicio",
					align: "center",
					sortable: true,
					value: "inicio",
				},
				{ 
					text: "Fin",
					align: "center",
					sortable: true,
					value: "fin",
				},
				// {
				//   text: "Tipo Paro",
				//   align: "center",
				//   sortable: true,
				//   value: "tiempoParo",
				// },
				{ 
					text: "Cantidad Reportada",
					align: "center",
					sortable: true,
					value: "cantidad",
				},
				{ 
					text: "Cantidad Auxiliar",
					align: "center",
					sortable: true,
					value: "auxiliar",
				},
				{ 
					text: "Eficiencia",
					align: "center",
					sortable: true,
					value: "eficiencia",
				},
				{ 
					text: "Pago Destajo",
					align: "center",
					sortable: true,
					value: "pagoDestajo",
				},
				{ 
					text: "STD",
					align: "center",
					sortable: true,
					value: "std",
				},
				{ 
					text: "Cantidad No Ok",
					align: "center",
					sortable: true,
					value: "cantidadNoOk",
				},
				{ 
					text: "Tiempo Paro",
					align: "center",
					sortable: true,
					value: "tiempoParo",
				},
				{ 
					text: "Causa Tiempo Paro",
					align: "center",
					sortable: true,
					value: "paros",
				},
				{ 
					text: "Costo No Calidad",
					align: "center",
					sortable: true,
					value: "costoTotal",
				},
				{ 
					text: "Merma",
					align: "center",
					sortable: true,
					value: "merma",
				},
				{ 
					text: "Scrap",
					align: "center",
					sortable: true,
					value: "scrap",
				},
				{ 
				 	text: "Acciones",
				 	align: "center",
				 	sortable: true,
				 	value: "actions",
				}
			],
			chartOptions: {
				chart: {
					type: "bar",
					height: 500,
					zoom: {
						enabled: true,
					},
				},
				dataLabels: {
					enabled: false,
				},
				colors: [() => this.getColor()],
				markers: {
					size: 1,
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"],
				},
				xaxis: {
					categories: [],
				},
				fill: {
					opacity: 1,
				},
			},
			chartOptionsDefault: {
				chart: {
					type: "bar",
					height: 500,
					zoom: {
						enabled: true,
					},
				},
				// plotOptions: {
				// 	bar: {
				// 		dataLabels: {
				// 			position: "top", // top, center, bottom
				// 		},
				// 	},
				// },
				dataLabels: {
					enabled: false,
					// formatter: function (val) {
					// 	return val.toFixed(2) + "%";
					// },
					// offsetY: -20,
					// style: {
					// 	fontSize: "12px",
					// 	colors: ["#304758"],
					// },
				},
				colors: [() => this.getColor()],
				markers: {
					size: 1,
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"],
				},
				xaxis: {
					categories: [],
				},
				yaxis: {
					labels: {
						formatter: function (val, index) {
							return val.toFixed(2) + " %";
						},
					},
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val.toFixed(2) + " %";
						},
					},
				},
				fill: {
					opacity: 1,
				},
			},
			historialChartOptions: {
				chart: { type: "bar", height: 500 },
				plotOptions: { bar: { horizontal: false } },
				dataLabels: { enabled: false },
				xaxis: { categories: [] },
				yaxis: {
					min: 0,
					max: 1,
					tickAmount: 5,
					labels: { formatter: (v) => Number(v).toFixed(1) }
				},
				tooltip: { y: { formatter: (v) => Number(v).toFixed(2) } },
			},
			historialSeries: [{ name: "Calificación", data: [] }],
			colors: [
				"#008FFB",
				"#00E396",
				"#FEB019",
				"#FF4560",
				"#775DD0",
				"#4CAF50",
				"#FF9800",
				"#1B998B",
				"#FA4443",
				"#A300D6",
			],
			colorsDummy: [
				"#008FFB",
				"#00E396",
				"#FEB019",
				"#FF4560",
				"#775DD0",
				"#4CAF50",
				"#FF9800",
				"#1B998B",
				"#FA4443",
				"#A300D6",
			],
		};
	},
	mounted() {
		this.initialize();
	},
	computed:{
		...mapState(["token","nuevoReporteOee", 'nombreEmpresa']),
		isTamto(){
			const n = (this.nombreEmpresa || '')
			return n === 'TAMTO';
		},
		historialMatrix() {
			// si faltan fechas, no hay tabla
			if (!this.desde || !this.hasta) {
				return { headers: [], items: [] };
			}

			const historial = Array.isArray(this.historialEdiciones) ? this.historialEdiciones : [];

			// si no hay historial, no hay columnas
			if (!historial.length) {
				return { headers: [{ text: "Día", value: "dia", align: "center" }], items: [] };
			}

			// ids seleccionados (si eliges operadores en el filtro)
			const selectedIds = (Array.isArray(this.idsPersonas) && this.idsPersonas.length)
				? new Set(this.idsPersonas)
				: null;

			// 1) columnas: SOLO desde historial (únicas por idPersonaAfectada)
			const colsMap = new Map(); // id => { id, key, name }
			for (const h of historial) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;

				// si hay filtro de operadores, limita columnas a los seleccionados
				if (selectedIds && !selectedIds.has(id)) continue;

				if (!colsMap.has(id)) {
				const name = (h?.nombrePersona || "").toString().trim();
				colsMap.set(id, {
					id,
					key: `op_${id}`,
					name: name || `ID ${id}`,
				});
				}
			}

			const cols = Array.from(colsMap.values());

			const headers = [
				{ text: "Día", value: "dia", align: "center" },
				...cols.map(c => ({ text: c.name, value: c.key, align: "center", sortable: false })),
			];

			// 2) idPersona => Set(días editados) (deduplica varias ediciones en el mismo día)
			const editedByPersona = new Map(); // id => Set('YYYY-MM-DD')
			for (const h of historial) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;

				if (selectedIds && !selectedIds.has(id)) continue;

				const dia = moment(h.fechaEdicion).format("YYYY-MM-DD");
				if (!editedByPersona.has(id)) editedByPersona.set(id, new Set());
				editedByPersona.get(id).add(dia);
			}

			// 3) rango de días (incluye hasta)
			const start = moment(this.desde, "YYYY-MM-DD");
			const end = moment(this.hasta, "YYYY-MM-DD");
			const dias = [];
			for (let d = start.clone(); d.isSameOrBefore(end, "day"); d.add(1, "day")) {
				dias.push(d.format("YYYY-MM-DD"));
			}

			// 4) filas normales (SI/NO)
			const items = dias.map(dia => {
				const row = { dia };
				for (const c of cols) {
				row[c.key] = editedByPersona.get(c.id)?.has(dia) ? "SI" : "NO";
				}
				return row;
			});

			// 5) fila TOTAL (porcentaje)
			const totalDias = dias.length || 1;
			const totalRow = { dia: "TOTAL" };
			for (const c of cols) {
				const siCount = editedByPersona.get(c.id)?.size ?? 0; // días únicos editados
				totalRow[c.key] = siCount / totalDias; // 0..1
			}
			items.push(totalRow);

			return { headers, items };
		},
		historialHeaders() {
			const m = this.historialMatrix || { headers: [], items: [] };
			return Array.isArray(m.headers) ? m.headers : [];
		},
		historialItems() {
			const m = this.historialMatrix || { headers: [], items: [] };
			return Array.isArray(m.items) ? m.items : [];
		},
		errorInicioParo() {
			const fmt = "YYYY-MM-DD HH:mm"
			if (!this.paroInicio) return "Dato requerido"
			const i = moment(this.paroInicio, fmt, true)
			if (!i.isValid()) return "Formato inválido (YYYY-MM-DD HH:mm)"

			if (this.paroFin) {
			const f = moment(this.paroFin, fmt, true)
			if (f.isValid() && i.isAfter(f)) return "Inicio no puede ser después de Fin"
			}
			return null
		},
		errorFinParo() {
			const fmt = "YYYY-MM-DD HH:mm"
			if (!this.paroFin) return "Dato requerido"
			const f = moment(this.paroFin, fmt, true)
			if (!f.isValid()) return "Formato inválido (YYYY-MM-DD HH:mm)"

			if (this.paroInicio) {
			const i = moment(this.paroInicio, fmt, true)
			if (i.isValid() && f.isBefore(i)) return "Fin no puede ser antes de Inicio"
			}
			return null
		},
		puedeGuardarParo() {
			return !this.errorInicioParo && !this.errorFinParo
		},
	},
	watch: {
		vista() {
			this.onFechasChange();
		},
		// si quieres que se refresque el historial cuando cambian fechas:
		desde() { if (this.vista === "historial") this.obtenerHistorialEdiciones(); },
		hasta() { if (this.vista === "historial") this.obtenerHistorialEdiciones(); },
		idsPersonas() { if (this.vista === "historial") this.obtenerHistorialEdiciones(); },
		inicio() { this.puedeGuardarFechas = this.validar(); },
		fin()    { this.puedeGuardarFechas = this.validar(); },
		infoDetalle(val) {
			if (val) this.setupStickyXScroll();
			else if (this._onResize) window.removeEventListener("resize", this._onResize);
		},
		reportes() {
			// si cambian filas/headers recalcula
			if (this.infoDetalle) this.setupStickyXScroll();
		},
		beforeDestroy() {
		  if (this._onResize) window.removeEventListener("resize", this._onResize);
		},
	},	
	methods: {
		descargarReporte(){
			var datetime = moment().format('YYYYMMDDHHmmss');
			let url = `/Reportes/ReporteEficienciaOperadorXlsx?access_token=${this.token}`;
			if(this.desde != null ) url += `&desde=${this.desde}`;
			if(this.hasta != null ) url += `&hasta=${this.hasta}`;
			if(this.idArea != null ) url += `&idArea=${this.idArea}`;
			if(this.idTurno != null ) url += `&idTurno=${this.idTurno}`;
			if (this.idsPersonas.length > 0) {
				this.idsPersonas.forEach(persona => {
					url += `&idsOperadores=${persona}`;
				});
			}
      		this.$utils.axios.downloadFile(url,'GET','operadores-eficiencia-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
		},
		getColor() {
			if (this.colorsDummy.length == 0) {
				this.colorsDummy = this.colors.map((color) => color);
			}
			return this.colorsDummy.pop();
		},
		nombrePersona: (persona) =>
			persona.nombre + " " + persona.paterno + " " + persona.materno,

		getPersonas() {
			if (!this.desde || !this.hasta) {
				this.resetValues();
				return Promise.resolve([]); // importante para que await no truene
			}

			this.idsPersonas = [];
			this.personas = [];

			return axios
				.get("/Personas/OperadoresRendimientoIntervalo", {
				params: { desde: this.desde, hasta: this.hasta },
				})
				.then((response) => {
				const raw = response.data || [];
				const uniq = new Map();

				for (const p of raw) {
					const id = p.idPersona ?? p.IdPersona;
					if (!id) continue;
					if (!uniq.has(id)) {
					uniq.set(id, {
						idPersona: id,
						nombre: p.nombre ?? p.Nombre ?? "",
						paterno: p.paterno ?? p.Paterno ?? "",
						materno: p.materno ?? p.Materno ?? "",
					});
					}
				}

				this.personas = Array.from(uniq.values());
				return this.personas;
				})
				.catch((error) => {
				// ❌ NO hay catch aquí, así que si falla axios, `this.personas` queda undefined
				console.log(error);
			});
		},
		// obtenerDatos() {
		// 	if (this.desde == null || this.hasta == null || this.cargando) {
		// 		this.resetValues();
		// 		this.idArea = null;
		// 		this.idTurno = null;
		// 		return;
		// 	}

		// 	this.cargando = true;

		// 	let url =this.nuevoReporteOee?"/Reportes/ReporteEficienciaOperadorOEE": "/Reportes/ReporteEficienciaOperador";
		// 	if (this.idsPersonas.length > 0) {
		// 		this.idsPersonas.forEach((persona, idx) => {
		// 			url +=
		// 				idx == 0
		// 					? `?idsOperadores=${persona}`
		// 					: `&idsOperadores=${persona}`;
		// 		});
		// 	}

		// 	axios
		// 		.get(url, {
		// 			params: {
		// 				desde: this.desde,
		// 				hasta: this.hasta,
		// 				idArea: this.idArea,
		// 				idTurno: this.idTurno,
		// 			},
		// 		})
		// 		.then((response) => {
		// 			var chartOptions = Object.assign(
		// 				{},
		// 				this.chartOptionsDefault
		// 			);
		// 			chartOptions.colors = [() => this.getColor()];
		// 			chartOptions.xaxis.categories = response.data.operadores;
		// 			this.chartOptions = chartOptions;
		// 			this.series = [];
		// 			this.series = response.data.series;
		// 			this.cargando = false;
		// 		})
		// 		.catch((error) => {
		// 			this.cargando = false;
		// 			this.series = [];
		// 			this.colorsDummy = this.colors.map((color) => color);
		// 			console.log(error);
		// 		});
		// },
		resetValues() {
			this.personas = [];
			this.idsPersonas = [];
			this.categories = [];
			this.series = [];
			this.chartOptions = Object.assign({},this.chartOptionsDefault);
			this.chartOptions.xaxis.categories = [];
			this.colorsDummy = this.colors.map((color) => color);
		},
		initialize() {
			this.getAreas();
			this.getTurnos();
		},
		getAreas() {
			axios
				.get("/Areas")
				.then((response) => {
					this.areas = response.data.filter(
						(area) => area.idArea > 1
					);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getTurnos() {
			axios
				.get("/Turnos")
				.then((response) => {
					this.turnos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		rowPasaFiltroOperadores(row, idsSeleccionados) {
			if (!idsSeleccionados || idsSeleccionados.length === 0) return true; // sin filtro
			if (!Array.isArray(row?.idsOperadores)) return false;
			// intersección:
			return row.idsOperadores.some(id => idsSeleccionados.includes(id));
		},
		getEficienciaValue(row) {
			const v = row?.eficiencia;
			if (v === null || v === undefined) return null;
			const n = typeof v === 'string' ? parseFloat(v.replace('%','')) : v;
			if (!Number.isFinite(n)) return null;
			if (n > 3000000 || n < 0) return null;
			return n;
		},

		getOperadoresFromRow(row) {
			if (Array.isArray(row?.operadores) && row.operadores.length) {
				return row.operadores
				.filter(x => typeof x === 'string' && x.trim())
				.map(x => x.trim());
			}
			return ['SIN OPERADOR'];
		},

		// Promedio simple por operador (incluye 0 reales, excluye "sin dato")
		// Promedio simple por operador usando idsOperadores[0] (1 operador)
		// Regresa SIEMPRE { categories: [], series: [{ name, data: [] }] }
		agruparPromedioSimple(rows, idsPermitidos, { incluirCeros = true } = {}) {
			const set = idsPermitidos?.length ? new Set(idsPermitidos) : null;
			const map = new Map(); // id => { sum, n }

			for (const r of (rows || [])) {
				const id = Array.isArray(r.idsOperadores) ? r.idsOperadores[0] : null;
				if (!id) continue;

				if (set && !set.has(id)) continue;

				const eff = this.getEficienciaValue(r);
				if (eff === null) continue;
				if (!incluirCeros && eff === 0) continue;

				const acc = map.get(id) ?? { sum: 0, n: 0 };
				acc.sum += eff;
				acc.n += 1;
				map.set(id, acc);
			}

			return map;
		},

		buildParamsSubpasos() {
			const p = { desde: this.desde, hasta: this.hasta };
			if (this.idTurno)  p.idsTurnos  = [this.idTurno];
			if (this.idArea)   p.idsAreas   = [this.idArea];
			if (this.idsPersonas?.length) p.idsPersonas = this.idsPersonas;
			return p;
		},
		buildUrlDetalleOperaciones(idsPersonas = []) {
			const sp = new URLSearchParams();
			sp.append("Desde", this.desde);
			sp.append("Hasta", this.hasta);

			if (this.idTurno) sp.append("IdsTurnos", this.idTurno);
			if (this.idArea) sp.append("IdsAreas", this.idArea);

			(idsPersonas || []).forEach((id) => {
				if (id !== null && id !== undefined && id !== "") {
					sp.append("IdsPersonas", id);
				}
			});

			return "/Reportes/ReporteCalidadSubpasos?" + sp.toString();
		},

		setOperadoresDesdeRows(rows) {
			const ids = new Set();
			const map = new Map();

			for (const r of (rows || [])) {
				const idsOps = Array.isArray(r.idsOperadores) ? r.idsOperadores : [];
				const names  = Array.isArray(r.operadores) ? r.operadores : [];

				idsOps.forEach((id, idx) => {
				if (!id) return;
				ids.add(id);

				const nombre = (names[idx] || names[0] || "").trim();
				if (nombre && !map.has(id)) map.set(id, nombre);
				});
			}

			this.idsOperadoresReporte = Array.from(ids);
			this.mapOperadorNombre = map;
		},

		resetColorsDummy() {
			const base = Array.isArray(this.colors) ? this.colors : [];
			this.colorsDummy = base.slice(); // copia segura
		},
		buildPersonasHistorial() {
			const byId = new Map();

			// 1) primero los de getPersonas
			for (const p of (this.personas || [])) {
				if (!p?.idPersona) continue;
				byId.set(p.idPersona, { ...p });
			}

			// 2) luego los del reporte (si ya los tienes)
			for (const id of (this.idsOperadoresReporte || [])) {
				if (!id || byId.has(id)) continue;
				const name = (this.mapOperadorNombre?.get?.(id) || "").trim();
				byId.set(id, { idPersona: id, nombre: name || `ID ${id}`, paterno: "", materno: "" });
			}

			// 3) finalmente los del historial (los que te faltan normalmente)
			for (const h of (this.historialEdiciones || [])) {
				const id = h?.idPersonaAfectada;
				if (!id || byId.has(id)) continue;
				const name = (h?.nombrePersona || "").trim();
				byId.set(id, { idPersona: id, nombre: name || `ID ${id}`, paterno: "", materno: "" });
			}

			this.personasHistorial = Array.from(byId.values());
		},
		formatearPromedioDesdeMap(avgMap) {
			// Convierte a lista de pares [id, acc]
			let entries = [];

			if (avgMap instanceof Map) {
				entries = Array.from(avgMap.entries());
			} else if (avgMap && typeof avgMap === "object") {
				// por si todavía llega como objeto plano
				entries = Object.entries(avgMap);
			} else {
				entries = [];
			}

			return entries
				.map(([idRaw, acc]) => {
				const id = Number(idRaw);
				const sum = Number(acc?.sum ?? acc?.sumEff ?? 0);
				const n   = Number(acc?.n   ?? acc?.nConDato ?? 0);

				const prom = n > 0 ? (sum / n) : 0;

				const name =
					(this.mapOperadorNombre instanceof Map && this.mapOperadorNombre.get(id))
					? this.mapOperadorNombre.get(id)
					: `ID ${id}`;

				return { id, name, value: +prom.toFixed(2) };
				})
				.filter(x => Number.isFinite(x.id));
		},
		normalizarNombreOperador(nombre) {
			return (nombre || "").toString().trim().replace(/\s+/g, " ").toLowerCase();
		},
		getIdPersonaPorNombre(nombre) {
			const buscado = this.normalizarNombreOperador(nombre);
			if (!buscado) return null;

			const persona = (this.personas || []).find((p) =>
				this.normalizarNombreOperador(this.nombrePersona(p)) === buscado
			);

			return persona?.idPersona ?? null;
		},
		getFilasDetalleDesdeRespuesta(data) {
			const candidatos = [
				data?.reportes,
				data?.detalles,
				data?.filas,
				data?.rows,
				data?.items,
			];

			const filas = candidatos.find((x) => Array.isArray(x));
			return filas || [];
		},
		async cargarDetalleOperacionesSeleccionadas() {
			if (!this.desde || !this.hasta) {
				this.reportes = [];
				return;
			}

			const ids = this.selectedOpId != null ? [this.selectedOpId] : [];
			const reqId = (this._detalleReqId = (this._detalleReqId || 0) + 1);
			this.cargandoTable = true;

			try {
				const resp = await axios.get(this.buildUrlDetalleOperaciones(ids));
				if (reqId !== this._detalleReqId) return;

				const rawRows = Array.isArray(resp.data) ? resp.data : this.getFilasDetalleDesdeRespuesta(resp.data);
				const rows = (rawRows || []).map((row) => ({
					...row,
					idsOperadores: Array.isArray(row?.idsOperadores)
						? row.idsOperadores
						: (this.selectedOpId != null ? [this.selectedOpId] : []),
					operadores: Array.isArray(row?.operadores)
						? row.operadores
						: (this.selectedOpId != null && this.selectedOpName ? [this.selectedOpName] : []),
				}));
				this.rowsRaw = rows;
				this.filtrarTablaPorSeleccion();
			} catch (error) {
				console.log(error);
				if (reqId !== this._detalleReqId) return;
				this.filtrarTablaPorSeleccion();
			} finally {
				if (reqId === this._detalleReqId) this.cargandoTable = false;
			}
		},
		async abrirDetalleEficienciaPorIndice(idx, categories = []) {
			if (idx < 0) return;

			this.selectedOpName = categories[idx] || "";
			this.selectedOpId = this.idsByCategory?.[idx] ?? this.getIdPersonaPorNombre(this.selectedOpName);
			this.infoDetalle = true;
			this.reportes = [];
			await this.cargarDetalleOperacionesSeleccionadas();
		},
		configurarClickBarrasEficiencia(chartOptions) {
			const opts = Object.assign({}, chartOptions);
			const categories = opts.xaxis?.categories || [];
			const abrir = (event, chartContext, config) => {
				const idx = config?.dataPointIndex ?? -1;
				if (idx < 0) return;
				this.abrirDetalleEficienciaPorIndice(idx, categories);
			};

			opts.chart = Object.assign({}, opts.chart, {
				events: Object.assign({}, opts.chart?.events || {}, {
					dataPointSelection: abrir,
					click: abrir,
				}),
			});

			return opts;
		},

		async obtenerDatos() {
			// ✅ 0) validaciones
			if (!this.desde || !this.hasta || this.cargando) {
				this.resetValues();
				this.idArea = null;
				this.idTurno = null;
				return [];
			}

			this.cargando = true;
			this.cargandoTable = true;
			this.reportes = [];

			try {
				// ============================================================
				// ======================= FLUJO TAMTO =========================
				// ============================================================
				if (this.isTamto) {
				const p = this.buildParamsSubpasos();

				const sp = new URLSearchParams();
				for (const [k, v] of Object.entries(p)) {
					if (Array.isArray(v)) v.forEach(x => sp.append(k, x));
					else if (v !== null && v !== undefined) sp.append(k, v);
				}

				const resp = await axios.get("/Reportes/ReporteCalidadSubpasos?" + sp.toString());
				const rowsRaw = Array.isArray(resp.data) ? resp.data : (resp.data?.filas || []);

				// normaliza eficiencia a número
				const toNum = (v) => {
					if (v === null || v === undefined) return -Infinity;
					if (typeof v === "string") {
					const n = parseFloat(v.replace("%", "").trim());
					return Number.isFinite(n) ? n : -Infinity;
					}
					return Number.isFinite(v) ? v : -Infinity;
				};

				const rows = rowsRaw
					.map(r => ({ ...r, eficiencia: toNum(r.eficiencia) }))
					.sort((a, b) => b.eficiencia - a.eficiencia);

				// ✅ importante: para “unión/join” posterior con historial
				// (este método debería llenar mapOperadorNombre e idsOperadoresReporte)
				this.setOperadoresDesdeRows(rows);

				this.rowsRaw = rows;
				this.reportes = rows;
				this.cargandoTable = false;
				this.colorsDummy = this.colors.map(c => c);

				// --- chart (reporte de eficiencia por operador) ---
				// ✅ aquí YA NO destructuramos {categories, series} porque ya no existe
				const avgMap = this.agruparPromedioSimple(rows, this.idsPersonas, { incluirCeros: false });

				// paired: [{id, name, value}]
				const paired = this.formatearPromedioDesdeMap(avgMap)
					.sort((a, b) => b.value - a.value);

				const chartOptions = Object.assign({}, this.chartOptionsDefault);
				chartOptions.colors = [() => this.getColor()];
				chartOptions.xaxis = chartOptions.xaxis || {};
				chartOptions.xaxis.categories = paired.map(p => p.name);

				// ✅ en vez de nameToId: ids paralelos directos
				this.idsByCategory = paired.map(p => p.id);

				this.chartOptions = this.configurarClickBarrasEficiencia(chartOptions);
				this.series = [{
					name: "Eficiencia",
					data: paired.map(p => p.value),
				}];

				this.cargando = false;
				return rows;
				}

				// ============================================================
				// ===================== FLUJO ORIGINAL =======================
				// ============================================================
				let url = this.nuevoReporteOee
				? "/Reportes/ReporteEficienciaOperadorOEE"
				: "/Reportes/ReporteEficienciaOperador";

				// idsOperadores en querystring como ya lo traías
				if (Array.isArray(this.idsPersonas) && this.idsPersonas.length > 0) {
				this.idsPersonas.forEach((persona, idx) => {
					url += idx === 0 ? `?idsOperadores=${persona}` : `&idsOperadores=${persona}`;
				});
				}

				const resp = await axios.get(url, {
				params: {
					desde: this.desde,
					hasta: this.hasta,
					idArea: this.idArea,
					idTurno: this.idTurno,
				},
				});

				const chartOptions = Object.assign({}, this.chartOptionsDefault);
				this.colorsDummy = this.colors.map(c => c);
				chartOptions.colors = [() => this.getColor()];

				chartOptions.xaxis = chartOptions.xaxis || {};
				chartOptions.xaxis.categories = resp.data?.operadores || [];
				this.idsByCategory = chartOptions.xaxis.categories.map((nombre) => this.getIdPersonaPorNombre(nombre));
				this.rowsRaw = [];
				this.reportes = [];

				this.chartOptions = this.configurarClickBarrasEficiencia(chartOptions);
				this.series = resp.data?.series || [];

				this.cargando = false;
				this.cargandoTable = false;
				return resp.data;

			} catch (error) {
				console.log(error);
				this.cargando = false;
				this.cargandoTable = false;
				this.series = [];
				this.colorsDummy = this.colors.map(c => c);
				return [];
			}
		},
		filtrarTablaPorSeleccion() {
			// si no hay rows, nada que filtrar
			if (!Array.isArray(this.rowsRaw)) {
				this.reportes = [];
				this.infoDetalle = false;
				return;
			}

			// filtra por ID, si existe
			if (this.selectedOpId != null) {
				this.reportes = this.rowsRaw.filter(r =>
				Array.isArray(r.idsOperadores) && r.idsOperadores.includes(this.selectedOpId)
				);
				this.infoDetalle = true;
				return;
			}

			// fallback por nombre
			const norm = (this.selectedOpName || '').trim().toLowerCase();
			if (norm) {
				this.reportes = this.rowsRaw.filter(r =>
				(r.operadores || []).some(x => (x || '').trim().toLowerCase() === norm)
				);
				this.infoDetalle = true;
				return;
			}

			// si no hay selección, muestra todo
			this.reportes = this.rowsRaw;
			this.infoDetalle = false;
		},
		closeInfoDetalle() {
			this.infoDetalle = false;
			this.selectedOpId = null;
			this.selectedOpName = "";
			this.filtrarTablaPorSeleccion(); // restaura la tabla completa sin reabrir el diálogo
		},
		onFechasInput() {
			clearTimeout(this._fechasTimer);
			this._fechasTimer = setTimeout(() => {
			this.onFechasChange();
			}, 150);
		},
		 showDialogEdit(idOperacionReal, inicio, fin) {
			const fmt = "YYYY-MM-DD HH:mm";

			this.inicio = moment(inicio, [fmt, "YYYY-MM-DD HH:mm:ss", moment.ISO_8601]).format(fmt);
			this.fin    = moment(fin,    [fmt, "YYYY-MM-DD HH:mm:ss", moment.ISO_8601]).format(fmt);

			this.idOperacionReal = idOperacionReal;
			this.dialogEditHour = true;

			// calcula si ya puede guardar al abrir
			this.puedeGuardarFechas = this.validar();
		},

		 sendDataDate(){
			if (!this.validar()) return;

			const fmt = "YYYY-MM-DD HH:mm";
			const Inicio = moment(this.inicio, fmt, true).toISOString();
			const Fin    = moment(this.fin,    fmt, true).toISOString();

			this.loadSave = true;
			axios.post("/Operadores/ModificarFehaHoraOMO/" + this.idOperacionReal, { Inicio, Fin })
				.then(async () => {
					await this.refrescarYRespetarDetalle();
					this.inicio = null;
					this.fin = null;
					this.errores.errorInicio = false;
					this.errores.errorInicioTexto = null;
					this.errores.errorFin = false;
					this.errores.errorFinTexto = null;
					this.idOperacionReal = null;
					this.dialogEditHour = false;
					this.loadSave = false;
				})
				.catch((error) => {
					this.loadSave = false;
					console.log(error);
				});
		},
		validar() {
			// reset básico
			this.errores.errorInicio = false;
			this.errores.errorInicioTexto = null;
			this.errores.errorFin = false;
			this.errores.errorFinTexto = null;

			// requeridos
			if (this.inicio == null && this.fin == null) {
				this.errores.errorInicio = true;
				this.errores.errorInicioTexto = "La fecha de Inicio es obligatorio";
				this.errores.errorFin = true;
				this.errores.errorFinTexto = "La fecha de Fin es obligatorio";
				return false;
			} else if (this.inicio == null && this.fin != null) {
				this.errores.errorInicio = true;
				this.errores.errorInicioTexto = "La fecha de Inicio es obligatorio";
				return false;
			} else if (this.inicio != null && this.fin == null) {
				this.errores.errorFin = true;
				this.errores.errorFinTexto = "La fecha de Fin es obligatorio";
				return false;
			}

			// formato + comparación por minuto
			const fmt = "YYYY-MM-DD HH:mm";
			const i = moment(this.inicio, fmt, true);
			const f = moment(this.fin, fmt, true);

			if (!i.isValid()) {
				this.errores.errorInicio = true;
				this.errores.errorInicioTexto = `Formato inválido. Usa ${fmt}`;
				return false;
			}
			if (!f.isValid()) {
				this.errores.errorFin = true;
				this.errores.errorFinTexto = `Formato inválido. Usa ${fmt}`;
				return false;
			}

			const iMin = i.clone().seconds(0).milliseconds(0);
			const fMin = f.clone().seconds(0).milliseconds(0);

			if (fMin.isBefore(iMin)) {
				this.errores.errorInicio = true;
				this.errores.errorInicioTexto = "Inicio no puede ser mayor que Fin.";
				this.errores.errorFin = true;
				this.errores.errorFinTexto = "Fin no puede ser menor que Inicio.";
				return false;
			}

			return true;
		},
		obtenerHistorialEdiciones() {
			if (!this.desde || !this.hasta) {
				this.historialEdiciones = [];
				return Promise.resolve([]);
			}

			this.cargandoHistorial = true;

			const params = { desde: this.desde, hasta: this.hasta };
			if (this.idsPersonas?.length === 1) params.idPersonaAfectada = this.idsPersonas[0];

			return axios.get("/Operadores/HistorialEdiciones", { params })
				.then((resp) => {
				this.historialEdiciones = Array.isArray(resp.data) ? resp.data : [];
				return this.historialEdiciones;
				})
				.catch((e) => {
				console.log(e);
				this.historialEdiciones = [];
				return [];
				})
				.finally(() => {
				this.cargandoHistorial = false;
				});
		},
		construirHistorialChart() {
			const historial = Array.isArray(this.historialEdiciones)
				? this.historialEdiciones
				: [];

			// 0) Rango sólo para referencia (ya no filtramos por aquí)
			const start = moment(this.desde, "YYYY-MM-DD", true);
			const end   = moment(this.hasta, "YYYY-MM-DD", true);
			const totalDias = (start.isValid() && end.isValid())
				? Math.max(end.diff(start, "days") + 1, 1)
				: 1;

			// 1) UNION de operadores: personas (getPersonas) + historial
			const colsMap = new Map(); // idPersona -> nombre

			// 1a) primero lo que venga en personas
			for (const p of (this.personas || [])) {
				const id = p?.idPersona;
				if (!id) continue;
				const nombre = (this.nombrePersona(p) || `ID ${id}`).toString().trim();
				if (nombre) colsMap.set(id, nombre);
			}

			// 1b) agrega los que existan en historial aunque no estén en personas
			for (const h of historial) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;
				if (!colsMap.has(id)) {
				const nombre = (h?.nombrePersona || `ID ${id}`).toString().trim();
				colsMap.set(id, nombre);
				}
			}

			// 1c) si hay filtro de operadores, aplica sobre la UNION
			let base = Array.from(colsMap, ([idPersona, nombre]) => ({ idPersona, nombre }));
			if (Array.isArray(this.idsPersonas) && this.idsPersonas.length) {
				const set = new Set(this.idsPersonas);
				base = base.filter(x => set.has(x.idPersona));
			}

			// orden alfabético por nombre
			base.sort((a, b) => a.nombre.localeCompare(b.nombre, "es"));

			// 2) mapa: idPersona -> número de ediciones en el rango
			const editsCount = new Map(); // key = idPersona (string) -> int

			for (const h of historial) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;
				const key = String(id);
				const curr = editsCount.get(key) || 0;
				editsCount.set(key, curr + 1);
			}

			// 3) categorías (nombres) y ids paralelos (para click en la barra)
			const categories = base.map(x => x.nombre);
			this.idsByHistCategory = base.map(x => x.idPersona);

			let scores = [];

			if (!editsCount.size) {
				// Si por alguna razón no hubo ediciones, todos en 1
				scores = base.map(() => 1);
			} else {
				// 4) Calcular score 0..1
				//    MAX_EDITS = cuántas ediciones equivalen a "0" de calificación
				const MAX_EDITS = 10; // ajusta esto a tu gusto

				scores = base.map(op => {
				const key = String(op.idPersona);
				const totalEdits = editsCount.get(key) || 0;

				// ratio de penalización (0 sin ediciones, 1 con >= MAX_EDITS)
				const ratio = Math.min(totalEdits, MAX_EDITS) / MAX_EDITS;
				const score = 1 - ratio; // 1 sin cambios, 0 con muchas ediciones

				return +score.toFixed(2);
				});
			}

			// 5) set chart
			this.historialChartOptions = {
				...this.historialChartOptions,
				xaxis: {
				...(this.historialChartOptions.xaxis || {}),
				categories,
				},
				chart: {
				...(this.historialChartOptions.chart || {}),
				events: {
					dataPointSelection: (event, chartContext, config) => {
					const idx = config?.dataPointIndex ?? -1;
					if (idx < 0) return;
					const id = this.idsByHistCategory?.[idx] ?? null;
					if (!id) return;
					this.abrirDiasModificadosPorOperador(id);
					},
				},
				},
			};

			this.historialSeries = [
				{
				name: "Calificación",
				data: scores,
				},
			];
		},

		formatDia(dia) {
			// dia viene como "YYYY-MM-DD"
			return moment(dia, "YYYY-MM-DD").format("DD/MM/YYYY");
		},
		formatFechaHora(v) {
			if (!v) return "—";

			const m = moment(String(v).trim(), [
				moment.ISO_8601,
				"YYYY-MM-DD HH:mm",
				"YYYY-MM-DD HH:mm:ss",
				"YYYY-MM-DD"
			], true);

			return m.isValid() ? m.format("YYYY-MM-DD HH:mm") : "—";
		},
		refrescarVista() {
			if (!this.desde || !this.hasta) {
			// limpia todo si no hay rango
			this.series = [];
			this.historialEdiciones = [];
			return;
			}

			if (this.vista === 'eficiencia') this.obtenerDatos();
			else this.obtenerHistorialEdiciones();
		},
		ocultarStd(item) {
			// Maneja nulos/strings y el caso nuevoReporteOee sin complicarte
			const rep = Number(item.cantidadReportada ?? item.cantidadReportada ?? 0);
			const eff = Number(item.eficiencia ?? 0); // 0 ó 0.xx: si es 0 sigue siendo 0
			return rep === 0 && eff === 0;
		},
		async onFechasChange() {
			if (!this.desde || !this.hasta) return;

			const rid = (this._ridFechas = (this._ridFechas || 0) + 1);

			await this.getPersonas();
			if (rid !== this._ridFechas) return;

			await this.obtenerDatos();              // aquí setOperadoresDesdeRows(rows)
			if (rid !== this._ridFechas) return;

			await this.obtenerHistorialEdiciones(); // llena historialEdiciones
			if (rid !== this._ridFechas) return;

			this.construirHistorialChart();
		},

		async obtenerHistorialEdiciones() {
			this.cargandoHistorial = true;
			try {
				const params = { desde: this.desde, hasta: this.hasta };
				if (this.idsPersonas?.length === 1) params.idPersonaAfectada = this.idsPersonas[0];

				const { data } = await axios.get("/Operadores/HistorialEdiciones", { params });
				this.historialEdiciones = Array.isArray(data) ? data : [];

				this.construirHistorialChart(); // ya no se queda sin personas
			} catch (e) {
				console.log(e);
				this.historialEdiciones = [];
				this.construirHistorialChart(); // pinta vacío si no hay data
			} finally {
				this.cargandoHistorial = false;
			}
		},
		getOperadoresBaseHistorial() {
			const out = new Map(); // idPersona => nombre

			// 1) Primero: los del reporte (eficiencia)
			(this.idsOperadoresReporte || []).forEach((id) => {
				if (!id) return;
				const n = this.mapOperadorNombre?.get?.(id);
				out.set(id, (n || `ID ${id}`).trim());
			});

			// 2) Luego: agrega los que SOLO existen en historial
			(this.historialEdiciones || []).forEach((h) => {
				const id = h?.idPersonaAfectada;
				if (!id) return;
				if (!out.has(id)) {
				const n = (h?.nombrePersona || "").toString().trim();
				out.set(id, n || `ID ${id}`);
				}
			});

			// 3) Opcional: si ya tienes this.personas, úsalo para mejorar nombres "ID X"
			(this.personas || []).forEach((p) => {
				const id = p?.idPersona;
				if (!id) return;
				const n = (this.nombrePersona(p) || "").trim();
				if (!n) return;

				if (!out.has(id)) out.set(id, n);
				else if ((out.get(id) || "").startsWith("ID ")) out.set(id, n);
			});

			// 4) Si el usuario seleccionó operadores, filtra a esos
			const selected = (Array.isArray(this.idsPersonas) && this.idsPersonas.length)
				? new Set(this.idsPersonas)
				: null;

			const arr = Array.from(out, ([idPersona, nombre]) => ({ idPersona, nombre }));
			return selected ? arr.filter(x => selected.has(x.idPersona)) : arr;
		},


		setOperadoresUnionParaHistorial() {
			const union = new Map(); // idPersona => nombre

			// 1) desde eficiencia
			const fromPersonas = new Map((this.personas || []).map(p => [p.idPersona, this.nombrePersona(p).trim()]));
			(this.idsOperadoresReporte || []).forEach(id => {
				const name = fromPersonas.get(id) || this.mapOperadorNombre?.get(id) || `ID ${id}`;
				union.set(id, name);
			});

			// 2) desde historial (agrega faltantes y también “rellena” nombre si estaba en ID ###)
			(this.historialEdiciones || []).forEach(h => {
				const id = h?.idPersonaAfectada;
				if (!id) return;

				const nameH = (h.nombrePersona || "").trim();
				if (!union.has(id)) {
				union.set(id, nameH || `ID ${id}`);
				} else {
				const cur = union.get(id) || "";
				if ((cur.startsWith("ID ") || !cur.trim()) && nameH) union.set(id, nameH);
				}
			});

			this.personasHistorial = Array.from(union, ([idPersona, nombre]) => ({ idPersona, nombre }));
			this.idsByHistCategory = this.personasHistorial.map(x => x.idPersona); // para click en barras
		},

		construirHistorialChart() {
			// 0) validaciones básicas de fechas
			if (!this.desde || !this.hasta) {
				this.idsByHistCategory = [];
				this.historialSeries = [{ name: "Calificación", data: [] }];
				this.historialChartOptions = {
				...this.historialChartOptions,
				xaxis: { ...(this.historialChartOptions?.xaxis || {}), categories: [] },
				};
				return;
			}

			const start = moment(this.desde, "YYYY-MM-DD", true);
			const end   = moment(this.hasta, "YYYY-MM-DD", true);
			if (!start.isValid() || !end.isValid()) return;

			// días en el rango (incluyente)
			const totalDias = Math.max(end.diff(start, "days") + 1, 1);

			// filtro opcional de operadores seleccionados
			const selectedIds =
				Array.isArray(this.idsPersonas) && this.idsPersonas.length
				? new Set(this.idsPersonas)
				: null;

			// 1) base de operadores desde this.personas
			let personasAll = Array.isArray(this.personas) ? this.personas : [];
			let base = selectedIds
				? personasAll.filter(p => selectedIds.has(p.idPersona))
				: personasAll;

			// fallback: si no hay personas en base, armamos desde el historial
			if (!base.length) {
				const hm = new Map(); // id => nombre
				const hist = Array.isArray(this.historialEdiciones) ? this.historialEdiciones : [];
				for (const h of hist) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;
				if (selectedIds && !selectedIds.has(id)) continue;
				if (!hm.has(id)) {
					hm.set(id, (h?.nombrePersona || `ID ${id}`).toString().trim());
				}
				}
				base = Array.from(hm, ([idPersona, nombrePersona]) => ({ idPersona, nombrePersona }));
			}

			// 2) quitar duplicados por idPersona
			const uniq = new Map();
			for (const p of base) {
				const id = p?.idPersona;
				if (!id) continue;
				if (!uniq.has(id)) uniq.set(id, p);
			}
			base = Array.from(uniq.values());

			// 3) contar ediciones por operador EN EL RANGO
			const editsCount = new Map(); // id => total de ediciones (NO por día)
			const historial = Array.isArray(this.historialEdiciones) ? this.historialEdiciones : [];

			for (const h of historial) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;
				if (selectedIds && !selectedIds.has(id)) continue;

				const m = moment(h.fechaEdicion);
				if (!m.isValid()) continue;

				// respeta el rango de fechas
				if (m.isBefore(start, "day") || m.isAfter(end, "day")) continue;

				editsCount.set(id, (editsCount.get(id) || 0) + 1);
			}

			// 4) construir categorías, ids y scores
			const idsByHistCategory = [];
			const categories = [];
			const scores = [];

			// máximo de ediciones permitidas = número de días del rango
			const maxEdits = totalDias;

			for (const p of base) {
				const id = p.idPersona;
				idsByHistCategory.push(id);

				// nombre amigable
				const nombre =
				typeof p.nombrePersona === "string" && p.nombrePersona.trim()
					? p.nombrePersona.trim()
					: (this.nombrePersona(p) || `ID ${id}`).trim();

				categories.push(nombre);

				const totalEdits = editsCount.get(id) || 0;

				// score 0..1 basado en totalEdits vs maxEdits (= totalDias)
				const ratio = maxEdits > 0 ? totalEdits / maxEdits : 0;
				let score = 1 - ratio;               // 0 ediciones -> 1, maxEdits ediciones -> 0
				score = Math.max(0, Math.min(1, score));

				scores.push(+score.toFixed(2));
			}

			// 5) si quieres ordenar por calificación (opcional)
			const paired = categories.map((name, i) => ({
				id: idsByHistCategory[i],
				name,
				score: scores[i],
			})).sort((a, b) => b.score - a.score);

			this.idsByHistCategory = paired.map(x => x.id);

			const opts = Object.assign({}, this.historialChartOptions);
			opts.xaxis = Object.assign({}, opts.xaxis, {
				categories: paired.map(x => x.name),
			});
			opts.chart = Object.assign({}, opts.chart, {
				events: {
				dataPointSelection: (event, chartContext, config) => {
					const idx = config?.dataPointIndex ?? -1;
					if (idx < 0) return;
					const id = this.idsByHistCategory?.[idx] ?? null;
					if (!id) return;
					this.abrirDiasModificadosPorOperador(id);
				}
				}
			});

			this.historialChartOptions = opts;
			this.historialSeries = [{ name: "Calificación", data: paired.map(x => x.score) }];
		},

		getOperadoresBase() {
			const setReporte = new Set(this.idsOperadoresReporte || []);
			const personasAll = Array.isArray(this.personas) ? this.personas : [];

			// si no han cargado personas, usamos fallback por nombre del reporte
			const basePersonas = personasAll.length
				? personasAll.filter(p => setReporte.has(p.idPersona))
				: (this.idsOperadoresReporte || []).map(id => ({
					idPersona: id,
					nombre: (this.mapOperadorNombre.get(id) || `ID ${id}`),
					paterno: "",
					materno: ""
				}));

			// si seleccionaste operadores, aplica filtro extra
			if (this.idsPersonas?.length) {
				const sel = new Set(this.idsPersonas);
				return basePersonas.filter(p => sel.has(p.idPersona));
			}

			return basePersonas;
		},

		construirCalificacion10() {
			const base = this.getOperadoresBaseHistorial(); // <-- JOIN real

			const start = moment(this.desde, "YYYY-MM-DD");
			const end = moment(this.hasta, "YYYY-MM-DD");
			const totalDias = Math.max(end.diff(start, "days") + 1, 1);

			// id => Set(días editados) (dedup por día)
			const editedDays = new Map();
			for (const h of (this.historialEdiciones || [])) {
				const id = h?.idPersonaAfectada;
				if (!id) continue;
				const dia = moment(h.fechaEdicion).format("YYYY-MM-DD");
				if (!editedDays.has(id)) editedDays.set(id, new Set());
				editedDays.get(id).add(dia);
			}

			// para click (índice barra -> id)
			this.idsByHistCategory = base.map(x => x.idPersona);

			const categories = base.map(x => x.nombre);

			const scores = base.map(x => {
				const edits = editedDays.get(x.idPersona)?.size ?? 0;   // 1 por día máximo
				const buenos = Math.max(0, totalDias - edits);
				const score = 10 * (buenos / totalDias);
				return +Math.max(0, Math.min(10, score)).toFixed(2);
			});

			const opts = Object.assign({}, this.historialChartOptions);
			opts.xaxis = Object.assign({}, opts.xaxis, { categories });
			opts.chart = Object.assign({}, opts.chart, {
				events: {
				dataPointSelection: (event, chartContext, config) => {
					const idx = config?.dataPointIndex ?? -1;
					if (idx < 0) return;
					const id = this.idsByHistCategory?.[idx];
					if (!id) return;
					this.abrirDiasModificadosPorOperador(id);
				}
				}
			});

			this.historialChartOptions = opts;
			this.historialSeries = [{ name: "Calificación", data: scores }];
		},


		abrirDiasModificadosPorOperador(idPersona) {
			this.selectedHistOpId = idPersona ?? null;

			// nombre: preferir personas, si no, fallback al historial
			const personasAll = Array.isArray(this.personas) ? this.personas : [];
			const p = personasAll.find(x => x.idPersona === idPersona);

			if (p) {
				this.selectedHistOpName = (this.nombrePersona(p) || "").trim();
			} else {
				const h0 = (this.historialEdiciones || []).find(x => x.idPersonaAfectada === idPersona);
				this.selectedHistOpName = ((h0?.nombrePersona || `ID ${idPersona}`) + "").trim();
			}

			const historial = Array.isArray(this.historialEdiciones) ? this.historialEdiciones : [];

			const start = moment(this.desde, "YYYY-MM-DD", true).startOf("day");
			const end   = moment(this.hasta, "YYYY-MM-DD", true).endOf("day");

			const byDia = new Map();

			for (const h of historial) {
				if (h?.idPersonaAfectada !== idPersona) continue;

				const m = moment(h.fechaEdicion);
				if (!m.isValid()) continue;
				if (m.isBefore(start) || m.isAfter(end)) continue;

				const dia = m.format("YYYY-MM-DD");
				const ts = m.valueOf();

				const curr = byDia.get(dia) || {
				dia,
				cantidadEdiciones: 0,
				ultimaFecha: null,

				inicioAntes: null,
				inicioDespues: null,
				finAntes: null,
				finDespues: null,

				// tipo (se calcula al final con flags)
				tipoEdicionLabel: null,
				_lastTs: -Infinity,
				_hasOp: false,
				_hasParo: false,

				detalles: [],
				};

				curr.cantidadEdiciones += 1;

				// flags de tipo
				if (h.tipoEdicion === 1) curr._hasOp = true;   // Operación
				if (h.tipoEdicion === 2) curr._hasParo = true; // Paro

				// guarda detalle (1 fila por edición)
				curr.detalles.push({
				fechaEdicion: h.fechaEdicion,
				tipoEdicion: h.tipoEdicion,
				tipoEdicionLabel: h.tipoEdicion === 2 ? "Paro" : "Operación",
				inicioAntes: h.inicioAntes ?? null,
				inicioDespues: h.inicioDespues ?? null,
				finAntes: h.finAntes ?? null,
				finDespues: h.finDespues ?? null,
				idOperacionReal: h.idOperacionReal ?? null,
				idParo: h.idParo ?? null,
				});

				if (ts > curr._lastTs) {
				curr._lastTs = ts;
				curr.ultimaFecha = m.format("YYYY-MM-DD HH:mm");

				curr.inicioAntes   = h.inicioAntes ?? null;
				curr.inicioDespues = h.inicioDespues ?? null;
				curr.finAntes      = h.finAntes ?? null;
				curr.finDespues    = h.finDespues ?? null;
				}

				byDia.set(dia, curr);
			}

			this.historialDiasItems = Array.from(byDia.values())
				.sort((a, b) => b.dia.localeCompare(a.dia))
				.map(({ _lastTs, _hasOp, _hasParo, ...rest }) => ({
				...rest,
				tipoEdicionLabel: (_hasOp && _hasParo) ? "Operación + Paro" : (_hasParo ? "Paro" : "Operación"),
				detalles: (rest.detalles || []).sort((x, y) => moment(y.fechaEdicion).valueOf() - moment(x.fechaEdicion).valueOf())
				}));

			this.dialogHistorialDias = true;
		},
		closeDialogHistorialDias() {
			this.dialogHistorialDias = false;
			this.selectedHistOpId = null;
			this.selectedHistOpName = "";
			this.historialDiasItems = [];
		},
		async refrescarYRespetarDetalle() {
			await this.obtenerDatos();

			// Si estabas viendo detalle (o hay selección), re-aplica filtro:
			if (this.selectedOpId != null || (this.selectedOpName || "").trim()) {
				this.filtrarTablaPorSeleccion();
			}
		},
		getTipoParos() {
			axios
				.get("/ParoTipos")
				.then((response) => {
				this.tipoParos = response.data;
				})
				.catch((error) => {
				console.log(error);
				});
		},
		getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
				this.tipoSubparos = response.data;
				})
				.catch((error) => {
				console.log(error);
				});
		},
		showDialogEditParo(p) {
			this.dialogEditParo = false
			this.paroInicio = null
			this.paroFin = null
			this.paroEdit.idParo = p.idParo
			this.paroEdit.condicion = (p.condicion ?? true)

			this.paroEdit.idParoTipo = p.idParoTipo
			this.paroEdit.idSubParoTipo = p.idSubParoTipo

			const fmt = "YYYY-MM-DD HH:mm"
			const parse = (v) => {
				if (!v) return null
				const m = moment(String(v).trim(), [fmt, "YYYY-MM-DD HH:mm:ss"], true)
				return m.isValid() ? m.format(fmt) : null
			}

			this.paroFin    = parse(p.fin)
			this.paroInicio = parse(p.inicio)

			this.getTipoParos()
			this.getTipoSubParos()

			this.paroDialogKey++

			this.$nextTick(() => {
				this.dialogEditParo = true
			})
		},
		guardarParo() {
			// 0) reset de errores
			this.erroresParo.errorInicio = false
			this.erroresParo.errorInicioTexto = null
			this.erroresParo.errorFin = false
			this.erroresParo.errorFinTexto = null

			// 1) validaciones mínimas
			if (!this.paroEdit?.idParo) {
				console.error("No hay idParo seleccionado")
				return
			}

			if (!this.paroEdit?.idParoTipo) {
				// si tu UX permite cambiar SOLO tiempo, quita este if
				this.erroresParo.errorFin = true
				this.erroresParo.errorFinTexto = "Selecciona la causa (Tipo de paro)."
				return
			}

			const fmt = "YYYY-MM-DD HH:mm"
			const mInicio = moment(this.paroInicio, fmt, true)
			const mFin = moment(this.paroFin, fmt, true)

			if (!mInicio.isValid()) {
				this.erroresParo.errorInicio = true
				this.erroresParo.errorInicioTexto = "Inicio inválido"
				return
			}
			if (!mFin.isValid()) {
				this.erroresParo.errorFin = true
				this.erroresParo.errorFinTexto = "Fin inválido"
				return
			}
			if (mFin.isBefore(mInicio)) {
				this.erroresParo.errorFin = true
				this.erroresParo.errorFinTexto = "Fin no puede ser menor que Inicio"
				return
			}

			const Inicio = mInicio.format(fmt) // "2025-12-01 07:59"
			const Fin = mFin.format(fmt)       // "2025-12-01 08:33"

			const payload = {
				idsReducidos: [this.paroEdit.idParo],
				idParoTipo: this.paroEdit.idParoTipo,
				inicio: Inicio,
				fin: Fin,
				condicion: this.paroEdit.condicion ?? true,
			}
			if (this.paroEdit.idSubParoTipo != null && this.paroEdit.idSubParoTipo !== "") {
				payload.idSubParoTipo = this.paroEdit.idSubParoTipo
			}

			this.loadSaveParo = true

			axios
				.put("/Paros/ActualizarTodosParos", payload)
				.then(async () => {
				// refresca tu reporte
				await this.refrescarYRespetarDetalle();

				// limpia/cierra
				this.dialogEditParo = false
				this.paroInicio = null
				this.paroFin = null
				this.paroCausa = null
				this.paroEdit = { idParo: null, idParoTipo: null, idSubParoTipo: null, condicion: true }

				this.erroresParo.errorInicio = false
				this.erroresParo.errorInicioTexto = null
				this.erroresParo.errorFin = false
				this.erroresParo.errorFinTexto = null
				})
				.catch((error) => {
				console.error("Error al actualizar el paro:", error)

				const msg =
					error?.response?.data?.message ||
					error?.response?.data?.Mensaje ||
					(typeof error?.response?.data === "string" ? error.response.data : null)

				if (msg) {
					this.erroresParo.errorFin = true
					this.erroresParo.errorFinTexto = msg
				}
				})
				.finally(() => {
				this.loadSaveParo = false
				})
		},
		getEficienciaDisplay(row) {
			const v = row?.eficiencia
			if (v === null || v === undefined) return null

			// si viene como "12.3%" quita %
			const n = typeof v === "string" ? parseFloat(v.replace("%", "")) : Number(v)
			if (!Number.isFinite(n)) return null

			// ✅ convertir a positiva SOLO visualmente
			return Math.abs(n)
		},
		cerrarParo() {
			this.dialogEditParo = false
			this.paroInicio = null
			this.paroFin = null
			this.paroCausa = null
			this.paroEdit = { idParo:null, idParoTipo:null, idSubParoTipo:null, condicion:true }
			this.erroresParo.errorInicio = false
			this.erroresParo.errorInicioTexto = null
			this.erroresParo.errorFin = false
			this.erroresParo.errorFinTexto = null
		},
		setupStickyXScroll() {
			this.$nextTick(() => {
				const tableRef = this.$refs.detalleTable;
				const sticky = this.$refs.stickyX;
				const stickyInner = this.$refs.stickyXInner;

				if (!tableRef || !sticky || !stickyInner) return;

				const wrap = tableRef.$el.querySelector(".v-data-table__wrapper");
				if (!wrap) return;

				const update = () => {
				const scrollW = wrap.scrollWidth;   // más confiable que table.scrollWidth
				const clientW = wrap.clientWidth;

				stickyInner.style.width = scrollW + "px";
				this.showStickyXScroll = scrollW > clientW + 2;
				};

				const onStickyScroll = () => {
				if (this._syncingX) return;
				this._syncingX = true;
				wrap.scrollLeft = sticky.scrollLeft;
				this._syncingX = false;
				};

				const onWrapScroll = () => {
				if (this._syncingX) return;
				this._syncingX = true;
				sticky.scrollLeft = wrap.scrollLeft;
				this._syncingX = false;
				};

				sticky.addEventListener("scroll", onStickyScroll, { passive: true });
				wrap.addEventListener("scroll", onWrapScroll, { passive: true });

				if (this._onResize) window.removeEventListener("resize", this._onResize);
				this._onResize = () => update();
				window.addEventListener("resize", this._onResize);

				update();
				sticky.scrollLeft = wrap.scrollLeft;
			});
		},
	},
};
</script>
<style scoped>
.historial-table tbody tr:nth-child(odd) {
  background: #fafafa;
}
.historial-table tbody tr:hover {
  background: #f1f5ff;
}

.sticky-dia {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white; /* importante para que no se transparente */
  min-width: 120px;
  max-width: 160px;
}

/* evita que los headers/celdas se corten raro */
.historial-table th,
.historial-table td {
  white-space: nowrap;
}

.total-row td {
  font-weight: 700;
}

/* 1) el wrapper interno de Vuetify: */
.mx-detalle-table .v-data-table__wrapper{
  overflow-x: auto !important;  /* ✅ siempre visible */
  overflow-y: auto !important;    /* mantiene scroll vertical usable */
}

.mx-xscroll-sticky{
position: sticky;
bottom: 0;
z-index: 5;
background: white;          /* o el color de tu card */
border-top: 1px solid rgba(0,0,0,0.08);
height: 18px;               /* alto del scrollbar */
overflow-x: auto;
overflow-y: hidden;
}

.mx-xscroll-inner{
  height: 1px;                /* solo para crear ancho scrolleable */
}

.mx-fecha-cell {
	font-size: 14px;       /* o 0.875rem */
	line-height: 1.2;
	white-space: nowrap;
}


</style>